import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { Close, ArrowDropUp, ArrowDropDown } from "@material-ui/icons";
import { Slider, FormLabel, FormControl } from "@mui/material";
import { Grid, Typography } from "@material-ui/core";

function valuetext(value) {
  return `${value} Hrs`;
}

function FlyDuration(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleUpdate = (e) => {
    setAnchorEl(e.target.value);
  };

  React.useEffect(() => {
    if (anchorEl) {
      const delayUpdate = setTimeout(() => {
        if (props.onChange) props.onChange(anchorEl);
      }, 1000);
      return () => {
        clearTimeout(delayUpdate);
      };
    }
  }, [anchorEl]);

  // const handleChange = (val) => {
  //   if (props.onChange) props.onChange(val);
  // };
  // const open = Boolean(anchorEl);
  // const id = open ? "simple-popover" : undefined;

  // const handleClear = (e) => {
  //   e.stopPropagation();
  //   handleChange(props.defaultValue);
  //   handleReset();
  // };
  // const handleReset = () => {
  //   if (props.onReset) props.onReset();
  // };

  return (
    <FormControl
      sx={{
        "&.MuiFormControl-root": {
          display: "block",
        },
        padding: "0 1rem",
      }}
    >
      <FormLabel
        id="fly-duration-filter"
        sx={{
          display: "block",
          fontWeight: "700",
          textAlign: "start",
          color: "#000000",
        }}
      >
        Fly Duration
      </FormLabel>
      <Slider
        aria-label="Max Fly Duration"
        defaultValue={1}
        getAriaValueText={valuetext}
        value={anchorEl}
        step={1}
        min={1}
        max={100}
        valueLabelDisplay="auto"
        onChange={handleUpdate}
        sx={{
          "& .MuiSlider-track": {
            color: "#00846A",
          },
          "& .MuiSlider-thumb": {
            backgroundColor: "white",
            border: "1px solid #00846A",
          },
        }}
      />
    </FormControl>
  );
}

export default React.memo(FlyDuration);

FlyDuration.defaultProps = {
  value: 1,
};
